'use client'

import {ReactNode, useEffect, useRef} from 'react'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {GameCodeMap} from '../types'

type Props = {
  children: ReactNode
  layout: string
  gameCodeMap: GameCodeMap
}

const AnchorEventWrapper = ({children, layout, gameCodeMap}: Props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClick = async (event: Event) => {
      const target = event.target as HTMLElement
      const anchor = target.closest('a')
      if (!anchor) return

      const gameCode = anchor.getAttribute('data-game-code')
      const gameData = gameCode && gameCodeMap[gameCode]

      if (gameData) {
        triggerAnalytics('game-card-clicked', {
          'game-name': gameData.nameEn,
          'game-code': gameCode,
          layout: layout,
        }).sendAll()
      }
    }

    const wrapper = wrapperRef.current
    if (wrapper) {
      wrapper.addEventListener('click', handleClick, {passive: true})
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('click', handleClick)
      }
    }
  }, [layout])

  return <div ref={wrapperRef}>{children}</div>
}

export default AnchorEventWrapper
